import { useTranslation } from "react-i18next"
import { observer } from "mobx-react-lite"
import React, { ReactNode } from "react"
import { useParams } from "../stores/uiStore"
import { useStore } from "../contexts/store"

import AccountButton from "./Header/AccountButton"
import PodImageHeader from "./Pod/PodImageHeader"
import Search from "./Elements/Search"
import Sidebar from "./Sidebar"

import { useSwipeable } from "react-swipeable"
import { Box, Button, Drawer } from "@mui/material"
import MenuIcon from '@mui/icons-material/Menu'
import MenuOpenIcon from '@mui/icons-material/MenuOpen'
import SyncStatus from "./Header/SyncStatus"
import { ArrowBack } from "@mui/icons-material"


const SidebarContainer = ({children}: {children: ReactNode}) => {
  const { t } = useTranslation()
  const { uiStore } = useStore()
  const { podId, tab } = useParams()
  const deviceWidth = uiStore.deviceWidth
  const sidebarIsOpen = uiStore.sidebarIsOpen
  const headerHeight = uiStore.headerHeight
  const smallScreen = deviceWidth === "tiny" || deviceWidth === "smaller" || deviceWidth === "small" || deviceWidth === "medium"
  const maxPageWidth = uiStore.maxPageWidth

  function toggleSidebarOpen() {
    uiStore.toggleSidebarIsOpen()
  }

  function handleSidebarClose() {
    uiStore.setSidebarIsOpen(false)
  }

  function navigateBackward() {
    if (window.history.state) {
      window.history.back()
    }
  }

  const handlers = useSwipeable({
    onSwipedLeft: handleSidebarClose,
  })

  const Header = () => (
    <Box sx={{
      justifySelf: "center",
      maxWidth: `${maxPageWidth}px`,
      width: "100%",
      alignContent: "center",
      alignItems: "center",
      backgroundColor: smallScreen ? "primary.main" : "back.main",
      display: "grid",
      gridTemplateColumns: smallScreen ? "max-content max-content auto max-content" : "auto max-content",
      gridTemplateRows: "auto",
      height: `${headerHeight}px`,
      padding: "0 25px"
    }}>
      {smallScreen === true &&
        <>
          <SidebarDrawer />
          <Button
            disabled={!window.history.state}
            onClick={navigateBackward}
            size="small"
            sx={{color: smallScreen ? "whitesmoke" : "primary.main"}}
            title={t('Back')||''}
          >
            <ArrowBack />
          </Button>
        </>
      }
      <Box sx={{textAlign:'right'}}>
        <SyncStatus style={{backgroundColor:'#eee'}} />
        <Search />
        <AccountButton />
      </Box>

    </Box>
  )

  const SidebarDrawer = () => (
      <Box>
        <Button
          onClick={toggleSidebarOpen}
          size="small"
          variant="classic"
        >
          {sidebarIsOpen ?
            <MenuOpenIcon sx={{fontSize: "20px"}} />
            :
            <MenuIcon sx={{fontSize: "20px"}} />
          }
        </Button>
        <Drawer
          anchor={"left"}
          open={sidebarIsOpen}
          onClose={handleSidebarClose}
          {...handlers}
          transitionDuration={{ appear: 100, enter: 100, exit: 100 }}
          sx={{
            marginTop: `${headerHeight}px`,
            '&.MuiDrawer-root .MuiModal-backdrop': { position: "absolute" },
            '&.MuiDrawer-root .MuiDrawer-paper': { marginTop: `${headerHeight}px`, height: `calc(100% - ${headerHeight}px)` },
          }}
        >
          <Sidebar />
        </Drawer>
      </Box>
  )

  if(smallScreen) return (
    <Box sx={{display: "grid", gridTemplateRows: "max-content auto", height: "100dvh"}}>
      <Header />
      {children}
    </Box>
  )

  return (
    <Box sx={{
      backgroundColor: "back.main",
      display: "grid",
      gridTemplateColumns: `max-content minmax(auto, ${maxPageWidth}px)`,
      height: "100dvh",
      justifyContent: "center",
      overflowY: "auto"
    }}>
      <Sidebar />
      <Box sx={{display: "grid", gridTemplateRows: "max-content auto", overflowY: "auto"}}>
        <Box sx={{padding: "15px 45px 0 45px"}}>
          {(podId === undefined || tab === "pdf")   ?
            <Header />
            :
            <Box sx={{
              margin: "0 15px"
            }}>
              <PodImageHeader>
                <SyncStatus />
                <Search />
                <AccountButton />
              </PodImageHeader>
            </Box>
          }
        </Box>
        {children}
      </Box>
    </Box>
  )

}

export default observer(SidebarContainer)